import React from "react";
import useVersionsData from "../hooks/useVersionsData";
import VehicleSpecs from "./VehicleSpecs";

const versionLabel = (v) => `${v.model_name} ${v.version_name}`.trim();

// Variante ficha: modelo ya cargado, sin selector ("Tu próximo Toyota").
const PrechargedCard = ({ version, info }) => {
    if (!version) {
        return (
            <div className="savings-calculator__empty">
                <strong>Vehículo no disponible</strong>
                <span>
                    La versión seleccionada no tiene datos energéticos cargados, por lo que
                    no es posible calcular el ahorro.
                </span>
            </div>
        );
    }

    const name = info.name || versionLabel(version);

    return (
        <React.Fragment>
            <div className="savings-calculator__precharged">
                <div className="savings-calculator__precharged-band">
                    <div className="savings-calculator__precharged-name">{name}</div>
                    <div className="savings-calculator__precharged-tag">
                        {info.motor ? `${info.motor} — Precargado` : "Precargado"}
                    </div>
                </div>
                {info.image ? (
                    <img
                        className="savings-calculator__precharged-image"
                        src={info.image}
                        alt={name}
                    />
                ) : null}
            </div>
            <VehicleSpecs version={version} />
        </React.Fragment>
    );
};

// Variante global: selector de modelos, hasta 4 para comparar.
const ModelPicker = ({
    selectedVersions,
    availableToAdd,
    canAddMore,
    onAdd,
    onRemove,
}) => (
    <React.Fragment>
        {selectedVersions.length > 0 ? (
            <ul className="savings-calculator__pills">
                {selectedVersions.map((v) => (
                    <li key={v.id} className="savings-calculator__pill">
                        <span>{versionLabel(v)}</span>
                        <button
                            type="button"
                            className="savings-calculator__pill-remove"
                            aria-label={`Quitar ${versionLabel(v)}`}
                            onClick={() => onRemove(v.id)}
                        >
                            ×
                        </button>
                    </li>
                ))}
            </ul>
        ) : null}

        {canAddMore ? (
            <div className="savings-calculator__select-wrap">
                <select
                    className="savings-calculator__select"
                    value=""
                    onChange={onAdd}
                >
                    <option value="" disabled>
                        {selectedVersions.length === 0
                            ? "Selecciona el modelo"
                            : "Agregar otro vehículo"}
                    </option>
                    {availableToAdd.map((v) => (
                        <option key={v.id} value={v.id}>
                            {versionLabel(v)}
                        </option>
                    ))}
                </select>
            </div>
        ) : null}

        {selectedVersions.length === 0 ? (
            <div className="savings-calculator__empty">
                <strong>Ningún modelo seleccionado</strong>
                <span>
                    Elige un modelo del listado para ver sus datos y calcular tu ahorro.
                </span>
            </div>
        ) : null}

        {selectedVersions.length === 1 ? (
            <VehicleSpecs version={selectedVersions[0]} />
        ) : null}
    </React.Fragment>
);

const Step1ModelSelect = () => {
    const {
        getVersions,
        getSelectedVersions,
        isSelected,
        canAddMore,
        isPrecharged,
        getPrechargedInfo,
        addVersion,
        removeVersion,
    } = useVersionsData();

    const precharged = isPrecharged();
    const selectedVersions = getSelectedVersions();

    const onSelectChange = (e) => {
        if (e.target.value) addVersion(e.target.value);
        e.target.value = "";
    };

    return (
        <section className="savings-calculator__card savings-calculator__step">
            <div className="savings-calculator__step-badge">1</div>
            <h3 className="savings-calculator__step-title">
                {precharged ? "Tu próximo Toyota" : "Elige el modelo Toyota"}
            </h3>
            {!precharged ? (
                <p className="savings-calculator__step-hint">
                    Puedes comparar hasta 4 modelos.
                </p>
            ) : null}

            {precharged ? (
                <PrechargedCard
                    version={selectedVersions[0]}
                    info={getPrechargedInfo()}
                />
            ) : (
                <ModelPicker
                    selectedVersions={selectedVersions}
                    availableToAdd={getVersions().filter((v) => !isSelected(v.id))}
                    canAddMore={canAddMore()}
                    onAdd={onSelectChange}
                    onRemove={removeVersion}
                />
            )}
        </section>
    );
};

export default Step1ModelSelect;
